import { HeaderContainer } from "../styleComponents/HeaderStyle";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@chakra-ui/react";

const NormalHeader = () =>{
    const navigate = useNavigate();
    
    return(
        <HeaderContainer>
            <Link to='/'> 
                <img src='/logot.png' alt="logo" className="logo"/>
            </Link>
            <div className="title">KPI System</div>
            <div className="right">
                <Button 
                    colorScheme="whatsapp"
                    bg="#25D366"
                    color="white"
                    _hover={{ bg: "#128C7E" }}
                    _active={{ bg: "#075E54" }}
                    onClick={() => navigate('/login')}
                >
                    <span className="mobile-text">Kirish</span>
                    <span className="desktop-text">Kabinetga kirish</span>
                </Button>
            </div>
        </HeaderContainer>
    )
}
export default NormalHeader;